<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M18 6L6 18M7.5 6H18v10.5"/>
</svg>
